import { inputDate } from '../../utils/dates';

export default {
  event: '',
  date: inputDate(new Date()),
  note: ''
};
